<template>
  <onboarding-complete />
</template>

<script>
import OnboardingComplete from '../../components/Onboarding/OnboardingComplete'
export default {
    components: {
        OnboardingComplete
    }
}
</script>

<style>

</style>